import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { headerStyles as invoiceHistoryStyles } from "@solveindustrial/Overrides/Widgets/InvoiceHistory/InvoiceHistoryHeader";
import { headerStyles as orderApprovalStyles } from "@solveindustrial/Overrides/Widgets/OrderApprovalList/OrderApprovalListHeader";
import { headerStyles as orderHistoryStyles } from "@solveindustrial/Overrides/Widgets/OrderHistory/OrderHistoryHeader";
import { savedOrderListHeaderStyles as savedOrderStyles } from "@solveindustrial/Overrides/Widgets/SavedOrderList/SavedOrderListHeader";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

/* Order history header section */
orderHistoryStyles.invoiceCountGridItem = {
    ...orderHistoryStyles.invoiceCountGridItem,
    width: 10,
};
orderHistoryStyles.toggleFilterGridItem = {
    ...orderHistoryStyles.toggleFilterGridItem,
    width: 2,
};
orderHistoryStyles.toggleFilterClickable = {
    ...orderHistoryStyles.toggleFilterClickable,
    css: css`
        ${orderHistoryStyles.toggleFilterClickable?.css}
        &:hover {
            ${TypographyStyle} {
                text-decoration: underline;
            }
        }
    `,
};
orderHistoryStyles.clearTypography = {
    forwardAs: "span",
    variant: "legend",
    color: colorStrings.primaryMain,
    css: css`
        margin-right: 16px;
    `,
};
orderHistoryStyles.toggleFilterIcon = {
    ...orderHistoryStyles.toggleFilterIcon,
    color: colorStrings.primaryMain,
};

/* Order approval header section */
orderApprovalStyles.orderApprovalCountGridItem = {
    ...orderApprovalStyles.orderApprovalCountGridItem,
    width: 10,
};
orderApprovalStyles.toggleFilterGridItem = {
    ...orderApprovalStyles.toggleFilterGridItem,
    width: 2,
    css: css`
        ${orderApprovalStyles.toggleFilterGridItem?.css}
        ${StyledButton} {
            &:hover {
                ${TypographyStyle} {
                    text-decoration: underline;
                }
            }
        }
    `,
};
orderApprovalStyles.clearTypography = {
    forwardAs: "span",
    variant: "legend",
    color: colorStrings.primaryMain,
    css: css`
        margin-right: 16px;
    `,
};
orderApprovalStyles.toggleFilterIcon = {
    ...orderApprovalStyles.toggleFilterIcon,
    color: colorStrings.primaryMain,
};

/* Saved order header section */
savedOrderStyles.titleGridItem = {
    ...savedOrderStyles.titleGridItem,
    width: 10,
};
savedOrderStyles.toggleFilterGridItem = {
    ...savedOrderStyles.toggleFilterGridItem,
    width: 2,
};
savedOrderStyles.toggleFilterClickable = {
    ...savedOrderStyles.toggleFilterClickable,
    css: css`
        ${savedOrderStyles.toggleFilterClickable?.css}
        &:hover {
            ${TypographyStyle} {
                text-decoration: underline;
            }
        }
    `,
};
savedOrderStyles.clearTypography = {
    forwardAs: "span",
    variant: "legend",
    color: colorStrings.primaryMain,
    css: css`
        margin-right: 16px;
    `,
};
savedOrderStyles.toggleFilterIcon = {
    ...savedOrderStyles.toggleFilterIcon,
    color: colorStrings.primaryMain,
};

/* Invoice history header section */
invoiceHistoryStyles.invoiceCountGridItem = {
    ...invoiceHistoryStyles.invoiceCountGridItem,
    width: 10,
};
invoiceHistoryStyles.toggleFilterGridItem = {
    ...invoiceHistoryStyles.toggleFilterGridItem,
    width: 2,
    css: css`
        ${invoiceHistoryStyles.toggleFilterGridItem?.css}
        ${StyledButton} {
            &:hover {
                ${TypographyStyle} {
                    text-decoration: underline;
                }
            }
        }
    `,
};
invoiceHistoryStyles.clearTypography = {
    forwardAs: "span",
    variant: "legend",
    color: colorStrings.primaryMain,
    css: css`
        margin-right: 16px;
    `,
};
invoiceHistoryStyles.toggleFilterIcon = {
    ...invoiceHistoryStyles.toggleFilterIcon,
    color: colorStrings.primaryMain,
};
